import { catchError, Observable, OperatorFunction, throwError } from 'rxjs';

type CatchAndLogErrorReporter = (error: unknown) => void;

let reporter: CatchAndLogErrorReporter | undefined;

// The operator runs in pipe callbacks outside any injection context, so the app registers its
// reporter here instead of the operator injecting one.
export function registerCatchAndLogErrorReporter(next: CatchAndLogErrorReporter | undefined): void {
  reporter = next;
}

/**
 * Always logs to the console. Re-throwing by default lets an unhandled error reach the app
 * ErrorHandler (and PostHog); passing `caught` swallows it, so only then is it sent to the
 * registered reporter.
 */
export function catchAndLogError<T, R = T>(caught?: Observable<R>): OperatorFunction<T, T | R> {
  return catchError((error) => {
    console.error(error);

    if (caught) {
      try {
        reporter?.(error);
      } catch (reporterError) {
        // A broken reporter must not turn a swallowed error back into a stream error.
        console.error(reporterError);
      }

      return caught;
    }

    return throwError(() => error);
  });
}
